import { forwardRef } from 'react';
import type { AnchorHTMLAttributes } from 'react';
import { Link } from '@tanstack/react-router';

type RouterLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & { href?: string; to?: string };

export const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(function RouterLink(
  { href, to, ...rest },
  ref,
) {
  const target = to ?? href ?? '/';
  if (/^[a-z]+:/i.test(target) || rest.target === '_blank') {
    return <a ref={ref} href={target} {...rest} />;
  }
  return <Link ref={ref} to={target} {...rest} />;
});
